<template>
  <div class="v2-view-recap-container">
    <template v-if="isBusy || isBusyResend">
      <div class="table-loader">
        <Preloader />
      </div>
    </template>
    <template v-else-if="currentStep === 5">
      <div class="v2-success-view">
        <div class="success-header">
          <div class="success-icon-badge">
            <font-awesome-icon icon="check" />
          </div>
          <h1>Merci pour votre souscription !</h1>
          <p>Votre contrat de garantie auto a été validé et enregistré.</p>
        </div>

        <div class="success-main-content">
          <div class="document-download-card">
            <div class="doc-info">
              <div class="doc-icon">
                <font-awesome-icon icon="file-pdf" />
              </div>
              <div class="doc-details">
                <h3>Certificat de Garantie</h3>
                <span>Format PDF • Prêt à imprimer</span>
              </div>
            </div>
            <button type="button" class="btn-download-pdf" @click="showPdf">
              <font-awesome-icon icon="eye" />
              Aperçu
            </button>
          </div>

          <div class="success-actions">
            <button type="button" class="btn-link-action" @click="restartFresh">
              <font-awesome-icon icon="plus-circle" />
              Souscrire à une autre garantie
            </button>
            <router-link to="/devis" class="btn-link-action secondary">
              <font-awesome-icon icon="th-list" />
              Voir mes devis
            </router-link>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <!-- Header Section -->
      <header class="v2-view-header">
        <div class="header-left">
          <!-- <router-link to="/devis" class="v2-back-link" v-if="showRetourButton">
            <font-awesome-icon icon="arrow-circle-left" />
            Retour
          </router-link> -->
          <h1>Devis en ligne</h1>
        </div>
        <div class="header-right" v-if="!currentStep">
          <router-link :to="'/garantie-moto-v2/' + $route.params.id" class="v2-modify-btn">
            <font-awesome-icon icon="pencil-alt" />
            Modifier
          </router-link>
        </div>
      </header>

      <div class="v2-view-grid">
        <!-- Main Column -->
        <main class="v2-main-col">
          <!-- <div class="v2-title-header-row">
            <div class="v2-view-section-title text-uppercase">
              RAPPEL DES INFORMATIONS COMMUNIQUÉES
            </div>
          </div> -->
          <!-- Warnings -->
          <div class="alert alert-warning mb-2" v-if="numberOfDuplicates > 0">
            <font-awesome-icon icon="exclamation-triangle" class="mr-2" />
            Attention ! Un contrat a déjà été saisi avec ce nom et ce numéro d’immatriculation.
          </div>

          <div class="v2-view-accordion-stack">
            <!-- Client Info Accordion -->
            <section class="v2-recap-accordion-item" :class="{ 'is-expanded': ownerExpanded }"
              v-if="insurance && insurance.client">
              <header class="accordion-header" @click="ownerExpanded = !ownerExpanded">
                <div class="header-title">
                  <font-awesome-icon icon="user-circle" />
                  <h2>Vos coordonnées</h2>
                </div>
                <i class="v2-chevron-icon"></i>
              </header>
              <div class="accordion-content" v-show="ownerExpanded">
                <div class="card-body grid-adaptive">
                  <div class="info-item" v-if="+insurance.client.civility !== CLIENT_CIVILITY.SOCIETE.ID">
                    <label>Civilité :</label>
                    <span class="info-val">{{ parseCivility(insurance.client.civility) }}</span>
                  </div>
                  <div class="info-item" v-else>
                    <label>Société :</label>
                    <span class="info-val">{{ insurance.client.name_of_signatory }}</span>
                  </div>

                  <div class="info-item">
                    <label>
                      {{
                        +insurance.client.civility !== CLIENT_CIVILITY.SOCIETE.ID ? 'Nom :' : 'Nom du signataire : '
                      }}
                    </label>
                    <span class="info-val">{{ insurance.client.last_name }}</span>
                  </div>

                  <div class="info-item" v-if="insurance.client.first_name">
                    <label>
                      {{
                        +insurance.client.civility !== CLIENT_CIVILITY.SOCIETE.ID ? 'Prénom :' : 'Prénom du signataire : '
                      }}
                    </label>
                    <span class="info-val">{{ insurance.client.first_name }}</span>
                  </div>

                  <div class="info-item">
                    <label>Email :</label>
                    <span class="info-val">{{ insurance.client.email }}</span>
                  </div>

                  <div class="info-item">
                    <label>Téléphone :</label>
                    <span class="info-val">{{ insurance.client.tel }}</span>
                  </div>

                  <div class="info-item" v-if="insurance.client.fax">
                    <label>Fax :</label>
                    <span class="info-val">{{ insurance.client.fax }}</span>
                  </div>

                  <div class="info-item">
                    <label>Adresse :</label>
                    <span class="info-val text-capitalize">{{ insurance.client.address }}, {{ insurance.client.zip }} {{
                      insurance.client.city }}</span>
                  </div>

                  <div class="info-item"
                    v-if="insurance.client && insurance.client.birthday && insurance.client.birthday != '1900-01-01 00:00:00'">
                    <label>Date de naissance :</label>
                    <span class="info-val">{{ parseBirthDate(insurance.client.birthday) }}</span>
                  </div>


                </div>
              </div>
            </section>

            <!-- Vehicle Info Accordion -->
            <section class="v2-recap-accordion-item" :class="{ 'is-expanded': vehicleExpanded }"
              v-if="insurance.details">
              <header class="accordion-header" @click="vehicleExpanded = !vehicleExpanded">
                <div class="header-title">
                  <font-awesome-icon icon="motorcycle" />
                  <h2>Votre Véhicule</h2>
                </div>
                <i class="v2-chevron-icon"></i>
              </header>
              <div class="accordion-content" v-show="vehicleExpanded">
                <div class="card-body grid-adaptive">
                  <div class="info-item">
                    <label>Immatriculation :</label>
                    <span class="info-val plate-style">{{ insurance.details.registration }}</span>
                  </div>

                  <div class="info-item">
                    <label>Garantie :</label>
                    <span class="info-val">{{ parseGarantie(insurance.details.garantie) }}</span>
                  </div>

                  <div class="info-item">
                    <label>Durée :</label>
                    <span class="info-val">{{ parseDuration(insurance.details.duration) }}</span>
                  </div>

                  <div class="info-item">
                    <label>Marque :</label>
                    <span class="info-val">{{ insurance.details.car_brand }}</span>
                  </div>

                  <div class="info-item">
                    <label>Modèle :</label>
                    <span class="info-val">{{ insurance.details.modele_porteur }}</span>
                  </div>

                  <div class="info-item">
                    <label>Appellation commerciale :</label>
                    <span class="info-val">{{ insurance.details.app_commercial }}</span>
                  </div>

                  <div class="info-item">
                    <label>Cylindrée :</label>
                    <span class="info-val">{{ parseCylinder(insurance.details.cylinder) }}</span>
                  </div>

                  <div class="info-item">
                    <label>Kilométrage :</label>
                    <span class="info-val">{{ insurance.details.km_sale_day || '-' }}</span>
                  </div>

                  <div class="info-item">
                    <label>Date de 1ère mise en circulation :</label>
                    <span class="info-val">{{ parseSaleDate(insurance.details) }}</span>
                  </div>

                  <div class="info-item">
                    <label>Date d'effet :</label>
                    <span class="info-val">{{ moment(insurance.details.effective_date).format("DD/MM/Y") }}</span>
                  </div>

                  <div class="info-item">
                    <label>Numéro de série :</label>
                    <span class="info-val">{{ insurance.details.serial_number }}</span>
                  </div>
                </div>
              </div>
            </section>

            <!-- Info & Disclaimer Accordion -->
            <section class="v2-recap-accordion-item" :class="{ 'is-expanded': infoExpanded }">
              <header class="accordion-header" @click="infoExpanded = !infoExpanded">
                <div class="header-title">
                  <font-awesome-icon icon="info-circle" />
                  <h2>Durée et Prise d'effet</h2>
                </div>
                <i class="v2-chevron-icon"></i>
              </header>
              <div class="accordion-content" v-show="infoExpanded">
                <div class="card-body">
                  <div class="v2-warranty-info-text">
                    <div class="v2-selected-plan-banner" v-if="insurance.details">
                      Vous avez choisi l'assurance moto
                      <strong>{{ parseGarantie(insurance.details.garantie) }}</strong>
                      pour une durée de
                      <strong>{{ parseDuration(insurance.details.duration) }}</strong>
                    </div>
                    <p v-if="mechanicCode != '705223'">
                      Sous r&eacute;serve du paiement de la prime et de l'acceptation de la garantie par
                      <strong>Dynassurances</strong>,
                      la garantie s'applique suivant la dur&eacute;e pr&eacute;cis&eacute;e aux conditions
                      particuli&egrave;res du contrat
                      et prendra fin automatiquement &agrave; 24 heures jour pour jour selon les dates indiqu&eacute;es
                      sur le certificat de garantie.
                    </p>
                    <p v-else>
                      Sous r&eacute;serve du paiement de la prime et de l'acceptation de la garantie,
                      la garantie s'applique suivant la dur&eacute;e pr&eacute;cis&eacute;e aux conditions
                      particuli&egrave;res du contrat
                      et prendra fin automatiquement &agrave; 24 heures jour pour jour selon les dates indiqu&eacute;es
                      sur le certificat de garantie.
                    </p>

                    <p class="font-weight-bold mt-3">Cependant la garantie prendra fin de plein droit avant son terme :
                    </p>
                    <ul class="v2-feature-list">
                      <li>
                        <font-awesome-icon icon="caret-right" />
                        <span>en cas de destruction du v&eacute;hicule, quelle qu'en soit la cause, par
                          r&eacute;siliation,</span>
                      </li>
                      <li>
                        <font-awesome-icon icon="caret-right" />
                        <span>en cas de d&eacute;ch&eacute;ance du b&eacute;n&eacute;ficiaire de la garantie pour non
                          respect des prescriptions du constructeur sur l'usage pour lequel le v&eacute;hicule est
                          con&ccedil;u.</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>

            <!-- Coverage Accordion -->
            <section class="v2-recap-accordion-item" :class="{ 'is-expanded': guaranteesExpanded }">
              <header class="accordion-header" @click="guaranteesExpanded = !guaranteesExpanded">
                <div class="header-title">
                  <font-awesome-icon icon="shield-alt" />
                  <h2>Garanties accordées</h2>
                </div>
                <i class="v2-chevron-icon"></i>
              </header>
              <div class="accordion-content" v-show="guaranteesExpanded">
                <div class="card-body">
                  <div class="v2-plan-accordion">
                    <div class="v2-accordion-item is-expanded">
                      <div class="v2-accordion-content">
                        <Accordes :insurance="insurance" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>

        <!-- Sidebar Section -->
        <aside class="v2-sticky-sidebar">
          <div class="v2-price-card">
            <div class="v2-price-header">
              <div class="v2-price-label">Prime totale T.T.C. (&euro;) *</div>
              <div class="v2-price-amount" v-if="getPrice">{{ getPrice }}</div>
              <div class="alert alert-danger p-2 rem-12" v-else>
                Les critères du véhicule ne permettent pas de souscrire à la garantie choisie.
              </div>
              <p class="price-note">* Frais de dossier et taxe attentats inclus.</p>
            </div>

            <div class="v2-price-details" v-if="insurance && insurance.assistance_price > 0">
              <div class="detail-row">
                <span>Dont pack assistance</span>
                <strong>
                  {{ roundEURWithoutSymbol(insurance.assistance_price).replace(".", ",") }} &euro;
                </strong>
              </div>
            </div>

            <div class="v2-actions-stack">
              <!-- Subscribe Button -->
              <button v-if="getGarantiePrice" class="btn-primary-outline" @click.prevent="changeStep()">
                <font-awesome-icon icon="rocket" />
                Souscrire à la garantie
              </button>

              <!-- Send Email Button -->
              <!-- <button v-if="insurance.mechanic && insurance.mechanic.client_payment == 1" class="btn-success-outline"
                @click.prevent="getPrice ? checkSubscription(insurance, resendEmail) : confirmSubscription()">
                <font-awesome-icon icon="envelope" />
                Envoyer le devis par e-mail
              </button> -->

              <!-- Save Button -->
              <button type="button" class="v2-btn-block outline"
                @click.prevent="mechanicCode != '705223' ? getFrontPdf() : getFrontPdfWL()">
                <font-awesome-icon icon="download" />
                Sauvegarder sur mon ordinateur
              </button>

              <!-- Print Button -->
              <button type="button" class="v2-btn-block outline"
                @click.prevent="mechanicCode != '705223' ? getFrontPdf(true) : getFrontPdfWL(true)">
                <font-awesome-icon icon="print" />
                Imprimer le détail de la garantie
              </button>

              <hr class="my-2">

              <!-- Close Button -->
              <button type="button" class="btn-secondary-outline" @click="closeQuote()">
                Fermer
              </button>
            </div>

            <div class="v2-price-footer">
              <div class="v2-contact-info">
                <span>CONTACTER OU SOUSCRIRE :</span>
                <p class="mb-0 fs-11"><a href="tel:+33148895757">01 48 89 57 57</a></p>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </template>
  </div>
</template>

<script>
import garantieFieldsList from "@/mixins/garantieFieldsLists";
import Preloader from "@/components/Preloader";
import Accordes from "../GarantiesAccordesMoto";
import insuranceMethods from "@/mixins/insuranceMethods";
import { CLIENT_CIVILITY } from "@/constants/client";
import pdfPreviewMixin from '@/mixins/pdfPreviewMixin';

export default {
  name: "GarantieMotoView",
  mixins: [garantieFieldsList, insuranceMethods, pdfPreviewMixin],
  components: {
    Preloader,
    Accordes,
  },
  props: {
    currentStep: {
      type: Number,
      required: true
    },
    customClass: {
      type: String,
      default: ''
    },
    insuranceData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isBusy: false,
      isBusyResend: false,
      insurance: {
        id: null,
        address: null,
        category: null,
        city: null,
        civility: null,
        email: null,
        first_name: null,
        last_name: null,
        tel: null,
        zip: null,
        details: null
      },
      showRetourButton: false,
      CLIENT_CIVILITY,
      pdfWindow: null,
      numberOfDuplicates: 0,
      ownerExpanded: true,
      vehicleExpanded: true,
      infoExpanded: false,
      guaranteesExpanded: false,
    };
  },
  computed: {
    getDownloadLink() {
      if (this.insurance.id)
        return this.getApiAuthUrl("garantie/generate-pdf/" + this.insurance.id);

      return "";
    },
    getDownloadLinkWL() {
      if (this.insurance.id)
        return this.getApiAuthUrl(
          "garantie/generate-pdfWL/" + this.insurance.id
        );

      return "";
    },
    getDownloadLinkConfirmationPdf() {
      if (this.insurance.id)
        return this.getApiAuthUrl(
          "garantie/confirmation-pdf/" + this.insurance.id
        );

      return "";
    },
    getDownloadLinkCopyPdf() {
      if (this.insurance.id)
        return this.getApiAuthUrl(
          "garantie/front-copy-pdf/" + this.insurance.id
        );

      return "";
    },
    getDownloadLinkCopyPdfWL() {
      if (this.insurance.id)
        return this.getApiAuthUrl(
          "garantie/front-copy-pdfWL/" + this.insurance.id
        );

      return "";
    },
    getPrice() {
      return this.insurance.price
        ? this.roundEURWithoutSymbol(this.insurance.price).replace(".", ",") +
        " €"
        : "";
    },
    getGarantiePrice() {
      return this.insurance.price && +this.insurance.price > 0;
    },
    mechanicCode() {
      let code =
        this.$store.state.userInfo && this.$store.state.userInfo.mechanic
          ? this.$store.state.userInfo.mechanic.code
          : null;
      return code ? code : "";
    },
  },
  methods: {
    showPdf() {
      this.show_pdf(this.insurance.id);
      // this.restartFresh();
    },
    restartFresh() {
      window.location.href = "/garantie-moto-v2";
    },
    changeStep(step = 5) {
      if (!this.insurance || !this.insurance.details || !this.insurance.details.serial_number) {
        this.showErrorNotificationText(
            "Le numéro de série (VIN) du véhicule est manquant.<br>" +
            "Veuillez retourner à l'étape 1, ouvrir le popup <strong>Modifier le véhicule</strong> " +
            "et saisir le Numéro de série (VIN) avant de souscrire à la garantie.",
            null
        );
        return;
      }
      this.getPDF();
    },
    confirmSubscription() {
      this.$confirm({
        message:
          "Les critères du véhicule ne permettent pas de souscrire à la garantie choisie. Etes-vous sûr de vouloir envoyer un devis sans prix à votre client ?",
        button: {
          no: "Non",
          yes: "Oui"
        },
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        callback: confirm => {
          if (confirm) {
            this.checkSubscription(this.insurance, this.resendEmail)
          }
        }
      });
    },
    getQuoteInfo(id) {
      if (!id || id === 'undefined') {
        return;
      }
      this.isBusy = true;
      let url = "garantie/" + id;
      this.apiGet(url)
        .then((response) => {
          this.isBusy = false;
          this.insurance = response.data.quote;
          this.numberOfDuplicates = response.data.duplicates;
        })
        .catch((error) => {
          this.showErrorNotification(error);
          this.$router.push("/");
        });
    },
    parseCivility(civility) {
      switch (+civility) {
        case 0:
          return "Monsieur";
        case 1:
          return "Mademoiselle";
        case 2:
          return "Madame";
        case 3:
          return "Société";
        case 4:
          return "Monsieur et Madame";
        default:
          return "";
      }
    },
    parseGarantie(garantie) {
      switch (+garantie) {
        case 1:
          return "Standard";
        case 2:
          return "Complète";
        default:
          return "";
      }
    },
    parseCarBrand(brand) {
      return this.list_marque_moto[brand] ? this.list_marque_moto[brand] : "";
    },
    parseSaleDate(details) {
      let day = details.day_circulation,
        month = details.month_circulation - 1,
        year = details.year_circulation;

      day.length < 2 ? (day = "0" + day.toString()) : "";
      month.length < 2 ? (month = "0" + month.toString()) : "";

      let date = this.moment(new Date()).date(day).month(month).year(year);
      return date.format("DD/MM/YYYY");
    },
    parseBirthDate(birthdate) {
      if (birthdate) {
        return this.moment(birthdate).format("DD/MM/Y");
      }

      return "";
    },
    parseCylinder(cylinder) {
      return this.list_cylinders_moto[cylinder]
        ? this.list_cylinders_moto[cylinder]
        : "";
    },
    parseDuration(duraion) {
      switch (+duraion) {
        case 1:
          return "3 Mois";
        case 2:
          return "6 Mois";
        case 3:
          return "12 Mois";
        default:
          return "";
      }
    },
    printInsurance() {
      this.ownerExpanded = true;
      this.vehicleExpanded = true;
      this.infoExpanded = true;
      this.guaranteesExpanded = true;

      setTimeout(() => {
        window.print();
      }, 300); // allow UI to update
    },
    resendEmail() {
      this.isBusyResend = true;
      let url = "garantie/resend-email/" + this.insurance.id;

      this.apiPost(url, {})
        .then((response) => {
          this.isBusyResend = false;
          if (response.data.quote && response.data.status == "success") {
            this.showSuccessNotification(response.data.message, "");
            this.$set(this.insurance, "was_sent", response.data.quote.was_sent);
            this.changeStep(5);
          }
        })
        .catch((error) => {
          this.isBusyResend = false;
          this.showErrorNotification(error);
        });
    },
    getConfirmationPDF() {
      this.refreshTokenForce()
        .then((response) => {
          if (this.getDownloadLinkConfirmationPdf) {
            let pdfWindow = window.open(this.getDownloadLinkConfirmationPdf);
            if (pdfWindow) this.pdfWindow = pdfWindow;
          } else {
            this.showWarningNotification("Quote Not Found");
          }
        })
        .catch((error) => {
          this.showErrorNotification(error);
        });
    },
    getPDF() {
      if (this.checkEffectiveDate(this.insurance)) {
        this.isBusy = true;
        this.refreshTokenForce()
          .then((response) => {
            if (this.getDownloadLink) {
              fetch(this.getDownloadLink, {
                method: 'GET',
                credentials: 'include'
              })
                .then(() => {
                  console.log('PDF generation triggered');
                })
                .catch(err => {
                  console.error('Error triggering PDF', err);
                });
            } else {
              this.showWarningNotification("Quote Not Found");
            }
          })
          .catch((error) => {
            this.showErrorNotification(error);
          }).finally(() => {
            this.isBusy = false;
            this.$emit('change-step', 5);
          });
      } else {
        this.showWarningNotification(
          "La garantie ne peut-être souscrite à une date antérieur. <br> Veuillez modifier la date de prise d'effet de la garantie."
        );
      }
    },
    getFrontPdf(stream = false) {
      this.refreshTokenForce()
        .then((response) => {
          if (this.getDownloadLinkCopyPdf) {
            if (stream) {
              window.open(this.getDownloadLinkCopyPdf + '&show_type=stream', '_blank');
            } else {
              window.open(this.getDownloadLinkCopyPdf);
            }
          } else {
            this.showWarningNotification("Quote Not Found");
          }
        })
        .catch((error) => {
          this.showErrorNotification(error);
        });
    },

    getFrontPdfWL(stream = false) {
      this.refreshTokenForce()
        .then((response) => {
          if (this.getDownloadLinkCopyPdfWL) {
            if (stream) {
              window.open(this.getDownloadLinkCopyPdfWL + '&show_type=stream', '_blank');
            } else {
              window.open(this.getDownloadLinkCopyPdfWL);
            }
          } else {
            this.showWarningNotification("Quote Not Found");
          }
        })
        .catch((error) => {
          this.showErrorNotification(error);
        });
    },
    closeQuote() {
      if (this.showRetourButton) {
        this.$router.push("/devis");
      } else {
        this.$router.push("/");
      }
    },
  },
  mounted() {
    if (this.insuranceData) {
      this.getQuoteInfo(this.insuranceData.id);
    } else if (this.$route.params.id) {
      this.getQuoteInfo(this.$route.params.id);
    }
    this.$eventBus.$emit("sidebar-set-active-tab", "Garantie Moto");

    if (this.$store.state.backToDevisListActive) {
      this.showRetourButton = true;
      this.$store.dispatch("backToDevisDisable");
    }
  },
  beforeDestroy() {
    this.$eventBus.$emit("sidebar-set-active-tab", "");
  },
  watch: {
    pdfWindow: function () {
      window.location.href = "/garantie-moto-v2";
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Garantie/moto/GarantieMotoView.vue